import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as nurse from "../services/nurseAPI";
const _ = require("lodash");

//? AlertU List (mutation because it's filter action)
export const useNurseAlertWithFilter = () => {
  return useMutation({
    mutationFn: (data) => nurse.getAgentAlertWithFilterNurse(data),
    retry: false,
  });
};

//* Get Shared Records
export const useGetSharedRecordsNurse = (params) => {
  return useQuery({
    queryKey: ["Shared-Records", params],
    queryFn: () => nurse.getSharedRecordsNurse({ consultationId: params }),
    enabled: !_.isEmpty(params),
    retry: false,
    refetchInterval: 8000,
  });
};

//* Get COD Details
export const useGetCODDetailsNurse = (params) => {
  return useQuery({
    queryKey: ["COD-Details", params],
    queryFn: () => nurse.getCODDetails({ urgenrtCareReqId: params }),
    enabled: !_.isEmpty(params),
    retry: false,
    refetchInterval: 5000,
  });
};

//* Get Profile Values
export const useGetProfileValuesNurse = (params) => {
  return useQuery({
    queryKey: ["Profile-Values", params],
    queryFn: () => nurse.getProfileValues(params),
    enabled: !!params?.memberId,
    retry: false,
  });
};

//* Get Profile DP
export const useGetProfileDPNurse = (params) => {
  return useQuery({
    queryKey: ["Profile-DP", params],
    queryFn: () => nurse.getProfileDP(params),
    enabled: !!params?.userId,
    retry: false,
  });
};

//? Update Start Service Status
export const useNurseJoinConsultation = () => {
  return useMutation({
    mutationFn: (data) => nurse.nurseJoinConsultation(data),
    retry: false,
  });
};

//* Get Consultations by consultation number
export const useGetConsultationsNurse = (params) => {
  return useQuery({
    queryKey: ["Consultations", params],
    queryFn: () => nurse.getConsultations({ consultationNumber: params }),
    enabled: !_.isEmpty(params),
    retry: false,
    refetchInterval: 5000,
  });
};

//? Update Nurse Leave
export const useUpdateUrgentCareNurseComments = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => nurse.updateUrgentCareNurseComments(data),
    retry: false,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries([
        "Consultations",
        variables.consultationNumber,
      ]);
    },
  });
};

//* Get Agent Details
export const useGetNurseByUserId = (params) => {
  return useQuery({
    queryKey: ["Agent-Details", params],
    queryFn: () => nurse.getAgentByUserId({ userId: params }),
    enabled: !_.isEmpty(params),
    retry: false,
  });
};

//* Get Consultation Messages
export const useGetConsultationMsgsNurse = (params) => {
  return useQuery({
    queryKey: ["Consultation-Messages", params],
    queryFn: () => nurse.getConsultationMessages({ consultationId: params }),
    enabled: !_.isEmpty(params),
    retry: false,
    refetchInterval: 2000,
  });
};

//?Send Consultation Message
export const useSendConsultationMessageNurse = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => nurse.sendConsultationMessage(data),
    retry: false,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries([
        "Consultation-Messages",
        variables.consultationId,
      ]);
    },
  });
};

//? Nurse List - Urgent care list
export const useUrgentCareNurseRequests = () => {
  return useMutation({
    mutationFn: (data) => nurse.urgentCareNurseRequests(data),
    retry: false,
  });
};

//? Nurse List
export const useTalkToNurseRequests = () => {
  return useMutation({
    mutationFn: (data) => nurse.talkToNurseRequests(data),
    retry: false,
  });
};

//? Get Docs By Id
export const useGetDocsByIdNurse = () => {
  return useMutation({
    mutationFn: (data) => nurse.getDocsById(data),
    retry: false,
  });
};

//? Get Case Notes on click
export const useCaseNotesURLV2Nurse = () => {
  return useMutation({
    mutationFn: (data) => nurse.caseNotesURLV2(data),
    retry: false,
  });
};

//* Get Nurse Upload Docs List
export const useGetNurseDocs = (params) => {
  return useQuery({
    queryKey: ["Nurse-UploadDocs", params],
    queryFn: () => nurse.getNurseUploadDocs(params),
    enabled: !_.isEmpty(params),
    retry: false,
  });
};

//? Upload Provider Doc
export const useUploadNurseDoc = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => nurse.uploadNurseDoc(data),
    retry: false,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries([
        "Nurse-UploadDocs",
        variables.userId || "",
      ]);
    },
  });
};

//? Update Document Capture Screen
export const useUpdateDocumentCaptureStatus = () => {
  return useMutation({
    mutationFn: (data) => nurse.updateDocumentCaptureStatus(data),
    retry: false,
  });
};

//* Get Menu Status
export const useGetDashboardMenuStatus = () => {
  return useQuery({
    queryKey: ["Dashbaord-MenuStatus"],
    queryFn: () => nurse.getDashboardMenuStatus(),
    retry: false,
    refetchInterval: 8000,
    refetchIntervalInBackground: true,
  });
};

//? Send Device Id
export const useSendDeviceIdNurse = () => {
  return useMutation({
    mutationFn: (data) => nurse.deviceTokenNurse(data),
    retry: false,
  });
};
